import { IconButton, TruncatedAccount } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { catcat as cc } from "cerulean";
import logoStyles from "../../PreviewCard/Logo.module.scss";
import styles from "./WirePaymentsTableScreen.module.scss";

type WireSelectedRecipientCardProps = {
  recipient: API.Recipient;
  rowIndex: number;
  onEditRecipient: (recipientId: API.RecipientId, rowIndex: number) => void;
  onClearRecipient: (rowIndex: number) => void;
  handleClickUnsavedRecipient?: (
    recipient: API.Recipient,
    rowIndex: number
  ) => void;
};

const WireSelectedRecipientCard = ({
  recipient,
  rowIndex,
  onEditRecipient,
  onClearRecipient,
  handleClickUnsavedRecipient,
}: WireSelectedRecipientCardProps) => {
  const { l10n } = useLocalization();
  const isUnsaved = recipient.hidden === true;

  return (
    <div
      className={cc(
        styles.selectedRecipientCardContainer,
        styles.interactive
      )}
    >
      <div className={styles.nameContainer}>
        <span className={styles.nameEllipsis}>
          {recipient.name}
        </span>
        <div className={styles.institutionNameContainer}>
          <div className={logoStyles.logo}>
            <span className="narmi-icon-bank" />
          </div>
          <span className="fontColor--secondary fontSize--xs">
            <TruncatedAccount
              lastFour={
                recipient.fedwire_destination?.account_number?.slice(
                  -4
                ) ?? ""
              }
              name={
                recipient.fedwire_destination?.institution_name ?? ""
              }
            />
          </span>
        </div>
      </div>
      <div className={styles.iconsContainer}>
        <IconButton
          kind="action"
          name="edit"
          label={l10n.getString("wire-payments-table-edit-recipient")}
          onClick={() => {
            if (isUnsaved && handleClickUnsavedRecipient) {
              handleClickUnsavedRecipient(recipient, rowIndex);
            } else {
              onEditRecipient(recipient.id, rowIndex);
            }
          }}
        />
        <IconButton
          kind="action"
          name="x"
          label={l10n.getString(
            "wire-payments-table-clear-recipient"
          )}
          onClick={() => onClearRecipient(rowIndex)}
        />
      </div>
    </div>
  );
};

export default WireSelectedRecipientCard;
